import { TabListProps, TabList as TabListRac } from "react-aria-components";
import { composeTailwindRenderProps } from "../../cn";

export default function TabList<T extends object>({
  className,
  ...props
}: TabListProps<T>) {
  return (
    <TabListRac
      {...props}
      className={composeTailwindRenderProps(
        className,
        "flex gap-2 overflow-hidden",
      )}
    />
  );
}
